import React, { createContext, useContext, useEffect, useState } from "react";
import { API_BASE, getToken, setToken, clearToken } from "../api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setTokenState] = useState(getToken());

  useEffect(() => {
    const onExpired = () => setTokenState(null);
    window.addEventListener("auth:expired", onExpired);
    return () => window.removeEventListener("auth:expired", onExpired);
  }, []);

  const authenticate = async (path, payload) => {
    const res = await fetch(`${API_BASE}/${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || "Something went wrong.");
    setToken(data.token);
    setTokenState(data.token);
  };

  const login = (username, password) => authenticate("login", { username, password });
  const signup = (username, email, password, inviteCode) => authenticate("signup", { username, email, password, inviteCode });
  const logout = () => {
    clearToken();
    setTokenState(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated: !!token, login, signup, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within an AuthProvider");
  return ctx;
};
